__turbopack_context__.v({
  "container": "MaturitySection-module-scss-module__pq7vNW__container",
  "header": "MaturitySection-module-scss-module__pq7vNW__header",
  "section": "MaturitySection-module-scss-module__pq7vNW__section",
});
